export default {
  methods: {
    notificationToast({ message = '', variant = '', title = '' }) {
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 3000,
        appendToast: false,
        variant,
      });
    },
  },
};
